import { render } from "./moneyinvolved.vue?vue&type=template&id=2d987d30&scoped=true"
import script from "./moneyinvolved.vue?vue&type=script&lang=js"
export * from "./moneyinvolved.vue?vue&type=script&lang=js"

import "./moneyinvolved.vue?vue&type=style&index=0&id=2d987d30&lang=css"
import "./moneyinvolved.vue?vue&type=style&index=1&id=2d987d30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d987d30"]])

export default __exports__